import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { ReclamationActionDetailCodes } from 'constants.js';
import { ReclamationActionDetailType } from 'constants.js';

const styles = (theme) => ({
    detailValue: {
        paddingLeft: theme.spacing(4)
    },

    input: {
        marginTop: 10
    },

    container: {
        display: 'flex',
        justifyContent: 'space-between'
    }
});

class DetailsComplementairesAffectationAutrui extends React.Component {

    constructor(props) {
        super(props);
                        

        this.state = {
            commentaire: ''
        };
    }

    componentDidMount() {
        const details = this.getDetails(this.state);
        this.props.onChange(details);
    }


    componentWillUnmount() {

        const details = {
            valide: true,
            items: []
        };

        this.props.onChange(details);
    }


    getDetails(newState) {

        const details = {
            valide: false,
            items: []
        };


        if (!newState.commentaire) {
            return details;
        }
                

        var detail = {
            code: ReclamationActionDetailCodes.Commentaire,
            type: ReclamationActionDetailType.Texte,
            libelle: 'Commentaire',
            position: details.items.length,
            valeurString: newState.commentaire
        };
        details.items.push(detail);


        details.valide = true;
        return details;

    }

    handleChange = (event) => {
        const newState = {
            ...this.state,
            [event.target.name]: event.target.value
        };

        this.setState(newState);

        const details = this.getDetails(newState);

        this.props.onChange(details);
    }

    render() {
        const { classes } = this.props;
        
        return (
            <React.Fragment>
                <Typography variant="body1" gutterBottom>Veuillez spécifier : </Typography>

                <TextField className={classes.input} id="commentaire" name="commentaire" label="Commentaire" type="text" value={this.state.commentaire} onChange={this.handleChange} fullWidth multiline />
            </React.Fragment>
        );
    }
}

DetailsComplementairesAffectationAutrui.propTypes = {
    onChange: PropTypes.func.isRequired
};

export default withStyles(styles)(DetailsComplementairesAffectationAutrui);